/* unplugin-vue-components disabled */import { render } from "./Close.vue?vue&type=template&id=39e168f8&ts=true"
import script from "./Close.vue?vue&type=script&lang=ts"
export * from "./Close.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__